import { translations as translationsSyncHistory } from "../../admin/VehicleSingleRegistrySyncHistoryPage/constants";
export const translations = {
  ...translationsSyncHistory,
  subtitle: {
    id: "vehicle.single.registry.sync.vehicleSingleRegistrySyncHistoryWidget.subtitle",
    defaultMessage:
      "Track the license plate synchronization status and submission history to other platforms.",
  },
  goBack: {
    id: "vehicle.single.registry.sync.vehicleSingleRegistrySyncHistoryWidget.goBack",
    defaultMessage: "Go back",
  },
};
